import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {computed, observable, override} from "mobx";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {BettingPromotionModuleConfig} from "../betting-promotion.module.config";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import type {BettingPromotionModuleTerms} from "../betting-promotion.module.terms";
import type {BettingPromotionBookieModel} from "../../../../../core/models/betting-promotion/betting-promotion.bookie.model";
import type {BettingPromotionBookieButtonModel} from "../../../../../core/models/betting-promotion/betting-promotion.bookie-button.model";
import {makeObservableClass} from "../../../../../infrastructure/decorators/observable";

@makeObservableClass
export class BettingPromotionModuleState extends BaseModuleState {
  terms: BettingPromotionModuleTerms;
  @observable popupVisibleCounter: Number;
  generatedGUID: String;
  ga4ClientId: String;
  ga4SessionId: String;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, BettingPromotionModuleConfig];

  @override get isPopulated(): Boolean {
    return this.appStore.state.appBettingPromotionDisplayModel.isVisible;
  }

  get type() {
    return this.appStore.state.appBettingPromotionDisplayModel.localStorageModel.type;
  }

  @computed get version(): String {
    const version = this.isPopup ? BETTING_PROMOTION.TYPES.popup : BETTING_PROMOTION.TYPES.banner;
    const device = this.device.isSmallView ? BETTING_PROMOTION.DEVICES.mobile : BETTING_PROMOTION.DEVICES.desktop;

    return `${version}${device}`;
  }

  @computed get bookie(): BettingPromotionBookieModel {
    const bookie: BettingPromotionBookieModel = this.appStore.state.appBettingPromotionDisplayModel.remoteConfigModel.currentBookie;

    return bookie;
  }

  @computed get logoHeight(): Number {
    const logoHeight: Number = this.isBanner && !this.device.isSmallView ? BETTING_PROMOTION.BOOKIE_LOGO.maxHeight : BETTING_PROMOTION.BOOKIE_LOGO.minHeight

    return logoHeight;
  }

  @computed get imageUrl(): String {
    const images: Array<String> = this.isPopup ? this.bookie.popup.backgroundImages : this.bookie.banner.backgroundImages;
    const random: Number = Math.floor(Math.random() * images.length)
    const currentImageSource: String = images[random];

    return currentImageSource;
  }

  @computed get buttons(): Array<BettingPromotionBookieButtonModel> {
    const buttons: Array<BettingPromotionBookieButtonModel> = [
      this.bookie.getButton,
      this.bookie.laterButton,
      this.bookie.notInterestedButton
    ];

    return buttons
  }

  @computed get isPopup(): Boolean {
    return this.type === BETTING_PROMOTION.TYPES.popup;
  }

  @computed get isBanner(): Boolean {
    return this.type === BETTING_PROMOTION.TYPES.banner;
  }

  get disclaimer(): String {
    return this.terms.BPROMOTION_DISCLAIMER;
  }
}
